import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { CustomizedSwitch, Loader, NotError } from 'components';
import { FindErrorItem, FindLoad, Images, PermissionList, RolePermission } from 'utils';
import { httpRequestsOnErrorsActions, systemActions } from 'store';

const GET_ACTION = 'GET_COMPANY';
const EDIT_ACTION = 'EDIT_COMPANY';

/** Other Settings → Billing & Diagnosis: the org-wide diagnosis matching switch (org-settings). */
export const DiagnosisMatchSettings = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.system.company);
    const loading = FindLoad(GET_ACTION);
    const editError = FindErrorItem(EDIT_ACTION);
    const [enabled, setEnabled] = useState(false);
    const canManage = RolePermission([PermissionList.COMPANY_PROFILE_MANAGE?.code]);

    useEffect(() => {
        if (company) setEnabled(!!company.diagnosisMatchEnabled);
    }, [company]);

    // The switch flips before the request ends; if it fails, show the saved value again.
    useEffect(() => {
        if (!editError) return;
        setEnabled(!!company?.diagnosisMatchEnabled);
        toast(<NotError type={'error'} errMessage={editError?.error || 'Could not save the setting. Please try again.'} />);
        dispatch(httpRequestsOnErrorsActions.removeError(EDIT_ACTION));
    }, [editError]);

    const save = (value) => {
        setEnabled(value);
        dispatch(systemActions.editCompany(company.id, { diagnosisMatchEnabled: value }, { mergeLatest: true }));
    };

    const handleToggle = () => {
        if (canManage) save(!enabled);
    };

    if (loading?.length) {
        return <Loader height={350} />;
    }

    return (
        <div className="supervision-settings-wrapper">
            <div className="supervision-section">
                <div className="eligibility-auto-box">
                    <div className="eligibility-auto-head" style={{ borderBottom: 'none', padding: 0 }}>
                        <div>
                            <p className="settings-subsection-title">Diagnosis matching</p>
                            <p className="settings-subsection-desc" style={{ margin: 0 }}>
                                Only bill diagnosis codes the client has and the payer service allows. Applies to services with “Require
                                diagnosis match” on.
                            </p>
                        </div>
                        <CustomizedSwitch checkedBgColor={'#0C66E4'} checked={enabled} handleClick={handleToggle} disabled={!canManage} />
                    </div>
                </div>
            </div>

            <div className="diagnoses-info-banner" style={{ marginTop: 12 }}>
                <img src={Images.infoCircleGray} alt="info" />
                <p>Off = today’s behaviour. Clients without diagnoses fall back to the payer service codes.</p>
            </div>
        </div>
    );
};
